module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero9.png?4c2982bc";